/**
 * Axios instance to comunicate to the Sequire IAM
 */
import axios from 'axios';

const IAM_API = axios.create({
  baseURL: process.env.IAM_API_URL,
  timeout: 300000,
  headers: {},
});

const AVAILABLE_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];

IAM_API.interceptors.request.use(async (config) => {
  const method = config.method || '';
  const checkMethod = AVAILABLE_METHODS.includes(method.toUpperCase());
  if (!checkMethod) throw new Error('Method param is invalid.');
  return config;
}, (error) => Promise.reject(error));

IAM_API.interceptors.response.use(
  async (response) => response,
  // TODO: Add maintenance interceptor
  async (error) => Promise.reject(error),
);

export default IAM_API;
